<template>
  <AppDialog
    v-model="isDialogOpen"
    :header="heading"
    :left-section="leftSection"
    :right-section="rightSection"
    @click:close="$emit('close')"
  >
    <div class="flex flex-col overflow-hidden">
      <AppAccordion default-closed>
        <template #header="{ toggleAccordion }"
          ><div @click="toggleAccordion">zzzzz</div></template
        >
        <template #content>asdasd</template>
      </AppAccordion>
    </div>
    <template #actions>
      <AppButton
        variant="outline"
        :label="cancelButtonLabel"
        @click="handleCancel"
      />
      <AppButton
        variant="primary"
        :label="confirmButtonLabel"
        @click="handleConfirm"
      />
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean
  heading: string
  leftSection: {
    header: string
    message: string
  }
  rightSection: {
    header: string
    message: string
  }
  confirmButtonLabel?: string
  cancelButtonLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  confirmButtonLabel: 'Confirm',
  cancelButtonLabel: 'Cancel',
})

const emit = defineEmits(['update:modelValue', 'resolve', 'close'])

const isDialogOpen = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  },
})

function handleConfirm() {
  emit('resolve', true)
  isDialogOpen.value = false
}

function handleCancel() {
  emit('resolve', false)
  isDialogOpen.value = false
}
</script>
